import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import SideMenu from "../../../components/menus/m-side";
import findImage from "../../../__utils/tools/find-image";
import tabOuSommesNous from "../../../__params/tab-pages/leclub/tab-ousommesnous";
import { useNavHeight } from "../../../__utils/context/navheightprovider";

const OuSommesNous = () => {
  const { navbarHeight } = useNavHeight();

  const [pointVisible, setPointVisible] = useState(true);
  const [mapExtVisible, setMapExtVisible] = useState(false);
  const [mapCouVisible, setMapCouVisible] = useState(false);

  const handlePointVisible = () => {
    setPointVisible(true);
    setMapExtVisible(false);
    setMapCouVisible(false);
  };

  const handleMapExtVisible = () => {
    setMapExtVisible(true);
    setMapCouVisible(false);
    setPointVisible(false);
  };

  const handleMapCouVisible = () => {
    setMapCouVisible(true);
    setMapExtVisible(false);
    setPointVisible(false);
  };

  return (
    <main role="main" className="mc-fond-europe">
      <Container fluid className="gx-0">
        <Row className="gx-0">
          <Col
            xs={12}
            md={3}
            className="gx-0"
            style={{
              position: "sticky",
              top: navbarHeight,
              zIndex: "1000",
            }}
          >
            <SideMenu />
          </Col>
          <Col xs={12} md={{ span: 7, offset: 1 }}>
            <div className="pt-5">
              <div
                className={
                  pointVisible
                    ? "mc-osn-point-visible mc-osn-point1-visible"
                    : "mc-osn-point-invisible"
                }
                onMouseEnter={handleMapExtVisible}
              >
                <span className="fs-6">?</span>
                <br />
                <span className="">courts extérieurs</span>
              </div>
              <div
                className={
                  pointVisible
                    ? "mc-osn-point-visible mc-osn-point2-visible"
                    : "mc-osn-point-invisible"
                }
                onMouseEnter={handleMapCouVisible}
              >
                <span className="fs-6">!</span>
                <br />
                <span className="">courts couverts</span>
              </div>

              <div
                onMouseLeave={handlePointVisible}
                className={
                  mapExtVisible ? "mc-osn-map-visible" : "mc-osn-map-invisible"
                }
              >
                <img
                  width={"100%"}
                  className="border border-2 rounded-2 border-warning"
                  src={findImage(tabOuSommesNous, "accesCourtsExt")}
                  alt=""
                />
              </div>

              <div
                onMouseLeave={handlePointVisible}
                className={
                  mapCouVisible ? "mc-osn-map-visible" : "mc-osn-map-invisible"
                }
              >
                <img
                  width={"100%"}
                  className="border border-2 rounded-1 border-danger"
                  src={findImage(tabOuSommesNous, "accesCourtsCouv")}
                  alt=""
                />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </main>
  );
};

export default OuSommesNous;
